// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d855a71b","732":"0eb8fd42","867":"fe3483f6","977":"d75cf9f7"}[chunkId] + ".chunk.js";
};